// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"6f127682","988":"2f8051f2"}[chunkId] + ".chunk.css";
};